import { Box } from "@mui/joy";
import { usePlatform } from "../../platform/PlatformProvider";
import { formatShortcut } from "../shortcuts";

const styles = {
    root: {
        fontFamily: "var(--font)",
        fontSize: "var(--type-caption)",
        lineHeight: "14px",
        py: "1px",
        px: 0.5,
        border: "1px solid",
        borderColor: "neutral.outlinedBorder",
        borderRadius: "4px",
        color: "text.tertiary",
        whiteSpace: "nowrap",
        flexShrink: 0,
    },
};

/** The small ⌘F / Ctrl+F badge inside a search field or a menu row. Decorative: screen
 *  readers skip it. `<Keycap spec="Mod+F" />`. */
export function Keycap({ spec }: { spec: string }) {
    const platform = usePlatform();
    return (
        <Box component="kbd" aria-hidden="true" sx={styles.root}>
            {formatShortcut(spec, platform.shortcuts.modifier)}
        </Box>
    );
}
